import { Typography } from "@mui/material"

type Props = {}

const EmailLabel = (props: Props) => {
  return <Typography variant="body1">Email</Typography>
}

export default EmailLabel
